import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';
import _ from 'lodash';
import moment from 'moment';

class WorkTeamListController {
  constructor($filter, EventEmitter) {
    'ngInject';
    this.filter = $filter;
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    moment.locale('es');
    this.currentMonthNumber = moment().format('MM'); 
    this.currentPreviousMonth = moment().month(this.currentMonthNumber-2).format('MMMM'); 
    this.secondPreviousMonth = moment().month(this.currentMonthNumber-3).format('MMMM'); 
    this.thirdPreviousMonth = moment().month(this.currentMonthNumber-4).format('MMMM'); 
    this.fourthPreviousMonth = moment().month(this.currentMonthNumber-5).format('MMMM'); 
    
    if(this.isMobileApp) {
      this.currentPreviousMonth = this.currentPreviousMonth.substr(0, 3);
      this.secondPreviousMonth = this.secondPreviousMonth.substr(0, 3);
      this.thirdPreviousMonth = this.thirdPreviousMonth.substr(0, 3);
      this.fourthPreviousMonth = this.fourthPreviousMonth.substr(0, 3);
    }

    this.months = [{name: this.currentPreviousMonth },{name: this.secondPreviousMonth},{name: this.thirdPreviousMonth},{name: this.fourthPreviousMonth}];
  }

  isEmpty() {
    return isUndefinedOrNullOrEmpty(this.employees)  || this._hasNotFilteredResults();
  }

  isLoaded() {
    return this.loaded === true;
  }

  _hasNotFilteredResults() {
    let filtered = this.filter('employeeFilter')(this.employees, this.filteredEmployees);
    return filtered.length === 0;
  }

  hasFilters(){
    return this.employeeFilters.length > 0;
  }

  onRemoveEmployeeFilter($event) {
    _.remove(this.filteredEmployees, filter => filter.employeeId === $event.employeeId);
  }

  onCleanEmployeeFilters() {
    this.onCleanSearch(this.EventEmitter({searchText : ''}));
  }

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
    };
  }
}

export default WorkTeamListController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/workTeamList/workTeamList.controller.js